import Month from '../models/Holiday';
import getNextHoliday from './getNextHoliday';
import months from '../months.json';

const setDataObject = (holidays) => {
    
    const { monthNames } = months;

    let holidayObject = {};
    if (holidays.length === 3 && holidays[1].item && holidays[1].item._id) {

        const calendar = monthNames.map((month, index) => {
            return new Month(index, monthNames[index], holidays[1].item._id);
        });
        const yearsShow = holidays.map((dataYear) => {
            let object = {
                status: '',
                disabled: '',
                yearNumber: (dataYear.item) ? dataYear.item._id : dataYear.pathYear,
            };
            if (!dataYear.item) {
                object['status'] = 'hide';
                object['disabled'] = 'disabled="disabled"';
            }
            return object
        });
        holidayObject.year = holidays[1].item._id;
        holidayObject.years = yearsShow;
        //holidayObject.meses = monthNames;
        holidayObject.calendarDays = calendar;
        holidayObject.calendarHolidays = holidays[1].item.holidays ? holidays[1].item.holidays : [];
        const date = new Date();
        let monthNum = date.getMonth()
        if (date.getFullYear() !== holidays[1].item._id) {
            monthNum = 0;
        }
        holidayObject.month = monthNames[monthNum];
        holidayObject.monthNum = monthNum;
        holidayObject.nextHoliday = getNextHoliday(holidays[1].item._id, holidayObject.calendarHolidays, date, monthNames);
        holidayObject.nextHolidayActive = (holidays[1].item._id === new Date().getFullYear()) ? true : false;
        if (typeof holidays[1].pathMonth !== 'undefined') {
            holidayObject.pathMonth = holidays[1].pathMonth;
        }
    } else {
        holidayObject.year = holidays[1]?.pathYear;
    }

    return holidayObject;

}

export default setDataObject;